import { render } from "./DeletedUsers.vue?vue&type=template&id=3ca516a9&lang=html"
import script from "./DeletedUsers.vue?vue&type=script&lang=js"
export * from "./DeletedUsers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__